export default __webpack_public_path__ + "static/media/login-logo.9fa4f389.png";